import React from "react";
import { MoonLoader } from "react-spinners";
import ScheduleTable from "./typeGame/strainght/ScheduleTable.tsx";
import FutureComponents from "./typeGame/future/FutureComponents.tsx";
import { useSport } from "../../context/SportContext.tsx";
import { SpecialData } from "./typeGame/strainght/specialData/SpecialData.tsx";
import { useIsSmallScreen } from "./SportsSchedule.tsx";
import "../../styles/ScheduleTable.css";

export function HomeContent() {

  const { activeFutureGames, activeGames, gameEspecial, loading } = useSport();
  const isSmallScreen = useIsSmallScreen();

  return (
    <div>
      {loading && !isSmallScreen && (
        <div className="loading-overlay-schedule">
          <MoonLoader color="#b6cc18" loading={loading} size={55} />
        </div>
      )}
      {activeGames.length > 0 && <ScheduleTable />}
      {gameEspecial.length > 0 && <SpecialData />}
      {activeFutureGames.length > 0 && <FutureComponents />}
    </div>
  );
}
